
export const TableController = { page: 1, rowsPerPage: 10, searchPage: 1, sortValue: null, sortOrder: -1, }
export const imageBaseUrl = "https://oevent-data.s3.me-central-1.amazonaws.com/oEventUploads/upload/"
export const imageSize = "thumbnail/512x512"
export const modalEnum = { open: false, data: null }
export const activeStatusOption = [
  { value: 'ALL', label: "All" },
  { value: true, label: "Active" },
  { value: false, label: "In-Active" },
]
export const vendorListFilterOption = [
  { value: "DISABLE", label: "Disabled Vendor" },
  { value: "DELETE", label: "Deleted vendor" },
]
export const teamListFilterOption = [
  { value: "accepted", label: "Accepted" },
  { value: "pending", label: "Pending" },
]

export const extraChargesOption = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: '15', label: "15" },
]
export const locationExtraChargesOption = [
  { value: "10", label: "10%" },
  { value: '20', label: "20%" },
]
export const serviceCategoryOption = [
  { value: "Event", label: "Event" },
  { value: 'Event2', label: "Event2" },
]
export const applicableQuantity = (t) => [
  { label: `${t("dropdown.yes")}`, value: true },
  { label: `${t("dropdown.no")}`, value: false, }
]
export const planDurationList = [
  { title: "Monthly", value: "MONTHLY" },
  { title: "Yearly", value: "YEARLY" },
]
export const planTypeList = [
  { title: "Flat Rate", value: "FLAT_RATE" },
  { title: "Commission Based", value: "COMM_BASED" },
]
export const offerTypeList = [
  { title: "Percentage", value: "PERCENTAGE" },
  { title: "Flat", value: "FLAT" },
]
export const booking_filter_keys = {
  search: "",
  disable_button: true,
  startDate: null,
  endDate: null,
}

export const statusDataList = [
  { title: "Active", value: true },
  { title: "In-Active", value: false },
]
export const filter_keys = {
  search: "",
  disable_button: true,
  service: [],
  date: null,
  status: [],
  client: []

}
export const subEventCategoryOptions = [
  { id: 1, key: "music_festival", value: "Music Festivals", label: "Music Festivals" },
  {id: 2, key: "circus_special", value: "Circus & Special Performances", label: "Circus & Special Performances" },
  {id: 3, key: "dj_club", value: "DJ & Club Events", label: "DJ & Club Events" },
  {id: 4, key: "matches", value: "Matches (Football/Basketball/etc)", label: "Matches (Football/Basketball/etc)" },
  {id: 5, key: "fitness", value: "Fitness Classes & Competitions", label: "Fitness Classes & Competitions" },
  { id: 6, key: "racing", value: "Racing Events (Car/Bike Races, Marathons)", label: "Racing Events (Car/Bike Races, Marathons)" },
  { id: 7, key: "business_tech", value: "Business & Tech Conferences", label: "Business & Tech Conferences" },
  {id: 8, key: "education_training",  value: "Educational & Training Workshops", label: "Educational & Training Workshops" },
  {id: 9, key: "art_culture", value: "Art & Cultural Exhibitions", label: "Art & Cultural Exhibitions" },
  {id: 10, key: "gala_dinner", value: "Gala Dinners & Exclusive Parties", label: "Gala Dinners & Exclusive Parties" },
  {id: 11, key: "networking_corporate", value: "Networking & Corporate Events", label: "Networking & Corporate Events" },
  {id: 12, key: "other", value: "Other", label: "Other" }
];
export const subEventCategoryOptions_ar = [
  { id: 1, key: "music_festival", value: "مهرجانات موسيقية", label: "مهرجانات موسيقية" },
  {id: 2, key: "circus_special", value: "سيرك وعروض خاصة", label: "سيرك وعروض خاصة" },
  {id: 3, key: "dj_club", value: "فعاليات منسقي الأغاني والأندية", label: "فعاليات منسقي الأغاني والأندية" },
  {id: 4, key: "matches", value: "مباريات (كرة قدم/كرة سلة/إلخ)", label: "مباريات (كرة قدم/كرة سلة/إلخ)" },
  {id: 5, key: "fitness", value: "دروس ومسابقات لياقة بدنية", label: "دروس ومسابقات لياقة بدنية" },
  { id: 6, key: "racing", value: "فعاليات سباقات (سباقات سيارات/دراجات، ماراثون)", label: "فعاليات سباقات (سباقات سيارات/دراجات، ماراثون)" },
  { id: 7, key: "business_tech", value: "مؤتمرات أعمال وتكنولوجيا", label: "مؤتمرات أعمال وتكنولوجيا" },
  {id: 8, key: "education_training",  value: "ورش عمل تعليمية وتدريبية", label: "ورش عمل تعليمية وتدريبية" },
  {id: 9, key: "art_culture", value: "معارض فنية وثقافية", label: "معارض فنية وثقافية" },
  {id: 10, key: "gala_dinner", value: "حفلات عشاء وحفلات خاصة", label: "حفلات عشاء وحفلات خاصة" },
  {id: 11, key: "networking_corporate", value: "فعاليات اجتماعية وفعاليات للشركات", label: "فعاليات اجتماعية وفعاليات للشركات" },
  {id: 12, key: "other", value: "أخرى", label: "أخرى" }
];


export const fileTypes = {
  pdf_File_Type: ["application/pdf"],
  Img_Type: [
    "image/jpg",
    "image/jpeg",
    "image/pjp",
    "image/png",
    "image/svg",
    "image/webp",
  ],
  video_Type: [
    'video/mp4',
    'video/webm',
    'video/ogg'
  ]
};

export const Validation = {
  pattern: {
    NAME: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
    NAMENumber: /^[a-zA-Z0-9]+(([',. -][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/,
    CLAIMNUMBER: /^[ A-Za-z0-9]*$/,
    REPORTNAME: /^[ A-Za-z]*$/,
    CODE: /^[ A-Za-z_@./#&+-/'/"]*$/,
    DURATION: /^[0-9]{0,3}$/,
    PRICING: /^[0-9.]{0,30}$/,
    CITY: /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/,
    EMAIL: /^(([^<>()\[\]\\.,,:\s@"]+(\.[^<>()\[\]\\.,,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    POSTAL_CODE: /^\d{5}-\d{4}|\d{4}|[A-Z]\d[A-Z] \d[A-Z]\d$/,
    PHONE_NO: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,4}$/,
    FIRM_NUMBER: /^[a-z0-9\-]+$/,
    ALPHANUM: /^[a-zA-Z0-9]+$/,
    MOB_NO: /\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/,
    // PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$#!%*?&])[A-Za-z\d$@$!%*?&]{6,}/,
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$#!%*?&])[A-Za-z\d$@#$!%*?&]{6,}/,

    DESCRIPTION: /^[ !@#$%^&*()~:;{}?'"=<>A-Za-z0-9_@./#&+-,-]*$/,
    REFNO: /^[ 0-9_@./#&+-,-]*$/,
    TASK_CODE: /^[0-9999]{1,4}$/,
    SUB_DOMAIN: /^[/a-z/A-Z][a-zA-Z0-9-]*[^/-/./0-9]$/,
    PHONE_NO_MASK: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    IVR_ACTION_KEY: /^[0-9]*$/,
    IVR_NUMBER: /^[1-9]*$/,
    RADIUS: /^[0-9]*(?:.)([0-9])+$/,
    LATLONG: /^\s*(\-?\d+(\.\d+)?)$/,
    SSN: /^((\d{3}-?\d{2}-?\d{4})|(X{3}-?X{2}-?X{4}))$/,
    SSN_MASK: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    PRACTICE_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
    USERNAME: /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){1,14}[a-zA-Z0-9]$/,
    USERNAME_MIN_SIZ: /^[a-zA-Z0-9_](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9_]){4,18}[a-zA-Z0-9_]$/,
    WICARE_USERNAME: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{1,}/,
    YEAR_MASK: /d{4}/,
    DECIMAL: /\d+(\.\d{1,2})?/,
    NUMBERnDECIMAL: '^\\d+(\\.\\d+)?$',
    MAXLENGTH: 50,
    MINLENGTH: 3,
    ONLYCHARATERS: /^[aA-zZ\s]+$/,
    ONLYDIGITS: /^[0-9]+$/,
    PASSWORDMINLENGTH: 6,
    PASSWORDMAXLENGTH: 15,
    MINIMUMVACANCY: 1,
    MAXIMUMVACANCY: 2,
    WHITESPACE: /^(?![\s-])[\w\s-]+$/,
    BACKSPACE: /^((?!\s{2,}).)*$/,
    ALPHANUMER: /^[a-zA-Z0-9]+$/,
    // BACKSPACE:.*\\S.*[a-zA-z0-9 ],
    URL: '^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + '(\\?[;&a-z\\d%_.~+=-]*)?' + '(\\#[-a-z\\d_]*)?$',
    phoneRegExp: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    isValidVideo: /\.(mp4|webm|ogg)$/i,

  }
}
export const countsPerPage = 1000
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const initialPermissions = {
  adminTeam: {
    add: { title: "Add", value: false },
    edit: { title: "Edit", value: false },
    delete: { title: "Delete", value: false },
    view: { title: "View", value: false },
  },
  // templateLibrary: {
  //   add: { title: "Add template library", value: false },
  //   edit: { title: "Edit template library", value: false },
  //   delete: { title: "Delete template library", value: false },
  //   view: { title: "View template library", value: false },
  // },
  // Chat: {
  //   edit: { title: "Edit chat", value: false },
  //   delete: { title: "Delete chat", value: false },
  //   view: { title: "View chat", value: false },
  // },
  // setUp: {
  //   servicesCategoriesManagement: { title: "Access services categories management", value: false },
  //   country: { title: "Access country", value: false },
  //   state: { title: "Access state", value: false },
  //   city: { title: "Access city", value: false },
  // },
  // rolesAndPermission: {
  //   addTeamMember: { title: "Add team member", value: false },
  //   editTeamMember: { title: "Edit team member", value: false },
  //   viewTeamMember: { title: "View team member", value: false },
  //   addPermission: { title: "Add permission", value: false },
  //   editPermission: { title: "Edit permission", value: false },
  //   viewPermission: { title: "View permission", value: false },
  // },
  // reviewManagement: {
  //   add: { title: "Add review", value: false },
  //   edit: { title: "Edit review", value: false },
  //   delete: { title: "Delete review", value: false }
  // },
  // planManagement: {
  //   add: { title: "Add plan", value: false },
  //   edit: { title: "Edit plan", value: false },
  //   delete: { title: "Delete plan", value: false }
  // },
  // paymentManagement: {
  //   add: { title: "Add payment", value: false },
  //   edit: { title: "Edit payment", value: false },
  //   delete: { title: "Delete payment", value: false }
  // },
  // notification: {
  //   read: { title: "Read notification", value: false },
  //   view: { title: "View notification", value: false },
  //   delete: { title: "Delete notification", value: false }
  // },
  // revenueReports: {
  //   add: { title: "Add revenue report", value: false },
  //   edit: { title: "Edit revenue report", value: false },
  //   delete: { title: "Delete revenue report", value: false }
  // },
  // ticketsEasy: {
  //   add: { title: "Add tickets", value: false },
  //   edit: { title: "Edit tickets", value: false },
  //   delete: { title: "Delete tickets", value: false }
  // },
  // setting: {
  //   policy: { title: "Access policy", value: false },
  //   changePaswword: { title: "Access change paswword", value: false },
  //   notification: { title: "Access notification ", value: false },
  //   queries: { title: "Access queries", value: false },
  // },
};
export const CKEditorCustomToolbar = [
  "bold",
  "italic",
  "link",
  "bulletedList",
  "numberedList",
  "blockQuote",
  "heading",
  "indent",
  "outdent",
  "table"
];